// src/components/ImagePopup.jsx
import { useEffect, useMemo, useState } from "react";

const DAY_MS = 24 * 60 * 60 * 1000;

const getPopupStorageKey = (popupId) => `eksys_popup_${popupId}_hideUntil`;

const isPopupHidden = (popupId) => {
  if (typeof window === "undefined") return false;

  const hideUntil = Number(localStorage.getItem(getPopupStorageKey(popupId)));

  if (!hideUntil) return false;

  return Date.now() < hideUntil;
};

const getPublicImageUrl = (src) => {
  if (!src) return "";
  if (src.startsWith("http") || src.startsWith("/")) return src;

  return `${process.env.PUBLIC_URL}/${src}`;
};

function ImagePopup({
  popupId,
  imageSrc,
  imageAlt = "",
  imageHref,
  title,
  description,
  children,
  href,
  linkLabel = "자세히 보기",
  expireDays = 1,
  index = 0,
  imageOnly = false,
  expiresAt,
}) {
  const [isPopupShow, setPopupShow] = useState(() => {
    return !isPopupHidden(popupId);
  });
  const expiresAtMs = expiresAt ? Date.parse(expiresAt) : null;
  const [isExpired, setIsExpired] = useState(() => {
    return expiresAtMs !== null && Date.now() >= expiresAtMs;
  });

  useEffect(() => {
    if (expiresAtMs === null || !Number.isFinite(expiresAtMs)) {
      setIsExpired(false);
      return;
    }

    let timer;
    const checkExpiration = () => {
      const remaining = expiresAtMs - Date.now();
      setIsExpired(remaining <= 0);
      if (remaining > 0) {
        // 긴 게시 기간도 setTimeout의 최대 지연 시간을 넘지 않도록 나눈다.
        timer = window.setTimeout(checkExpiration, Math.min(remaining, DAY_MS));
      }
    };

    checkExpiration();
    return () => window.clearTimeout(timer);
  }, [expiresAtMs]);

  const imageUrl = useMemo(() => getPublicImageUrl(imageSrc), [imageSrc]);

  const closePopup = () => {
    setPopupShow(false);
  };

  const closePopupForDays = (days) => {
    const hideUntil = Date.now() + days * DAY_MS;

    localStorage.setItem(
      getPopupStorageKey(popupId),
      String(hideUntil)
    );

    closePopup();
  };

  if (!isPopupShow || isExpired) return null;

  return (
    <aside
      className={`image_popup${imageOnly ? " image_popup--image-only" : ""}`}
      style={{ "--popup-index": index }}
      role="dialog"
      aria-label={title || imageAlt || "공지 팝업"}
    >
      <div className="image_popup_media">
        {imageHref ? (
          <a
            href={imageHref}
            className="image_popup_image_link"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${imageAlt || "공지 안내"} (새 탭에서 열기)`}
          >
            <img src={imageUrl} alt={imageAlt} className="image_popup_image" />
          </a>
        ) : (
          <img src={imageUrl} alt={imageAlt} className="image_popup_image" />
        )}
      </div>

      {!imageOnly && <div className="image_popup_body">
        {title && <h3>{title}</h3>}

        {description && (
          <p className="image_popup_description">
            {description}
          </p>
        )}

        {children}

        {href && (
          <a
            href={href}
            className="image_popup_link"
            target="_blank"
            rel="noreferrer"
          >
            {linkLabel}
          </a>
        )}
      </div>}

      <div className="image_popup_footer">
        <button
          type="button"
          className="image_popup_today"
          onClick={() => closePopupForDays(expireDays)}
        >
          <span aria-hidden="true" />
          오늘 하루 안 보기
        </button>

        <button
          type="button"
          className="image_popup_close"
          onClick={closePopup}
        >
          닫기
        </button>
      </div>
    </aside>
  );
}

export default ImagePopup;
// import { useEffect, useState } from "react";

// function ImagePopup({ children, popupId }) {
//   const shouldHidePopup = () => {
//     const expireDay = localStorage.getItem(`${popupId}_popupNoShow`);
//     const now = Date.now();

//     if (!expireDay) return false;
//     return now < Number(expireDay);
//   };

//   const [isPopupShow, setPopupShow] = useState(() => {
//     return !shouldHidePopup();
//   });

//   const closePopup = (expireDays) => {
//     const expire = new Date();
//     expire.setTime(expire.getTime() + expireDays * 24 * 60 * 60 * 1000);
//     localStorage.setItem(`${popupId}_popupNoShow`, String(expire.getTime()));
//   };

//   const closePopupToday = () => {
//     closePopup(1);
//     setPopupShow(false);
//   };

//   const [windowSize, setWindowSize] = useState({
//     width: window.innerWidth,
//     height: window.innerHeight,
//   });

//   useEffect(() => {
//     const handleResize = () => {
//       setWindowSize({
//         width: window.innerWidth,
//         height: window.innerHeight,
//       });
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   if (!isPopupShow) return null;

//   return (
//     <div className="image_popup">
//       <div className="image_popup_content">
//         <img
//           src={process.env.PUBLIC_URL+"images/shared image (2).jpeg"}
//           alt=""
//           style={{
//             width: "100%",
//             height: `${(windowSize.width * 0.4 * 9) / 16}px`,
//           }}
//         />
//         {children}
//       </div>

//       <div className="image_popup_footer">
//         <input type="checkbox" id={`check_${popupId}`} onChange={closePopupToday} />
//         <label htmlFor={`check_${popupId}`}>오늘 하루 안 보기</label>

//         <div
//           className="onday_popup-close"
//           onClick={() => setPopupShow(false)}
//         >
//           <span className="close_popup_btn">닫기</span>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ImagePopup;
